import React, { Component } from "react";
import './footer.scss';



export class Footer extends Component {
	state = {
		mobile: false
	}

	componentDidMount() {
		window.addEventListener("resize", () => {
			if (window.innerWidth < 760) {
				this.setState({
					mobile: true
				})
			} else {
				this.setState({
					mobile: false
				})
			}
		});


  }
	componentWillReceiveProps(){
		window.addEventListener("resize", () => {
			if (window.innerWidth < 760) {
				this.setState({
					mobile: true
				})
			} else {
				this.setState({
					mobile: false
				})
			}
		});
	}
	render(){
		let { mobile } = this.state;
		return (
			<div className="Footer">
				<footer>
					<div className="payment-info">
						<div className="dx-col">
			      {mobile ? (

							<div className="footer_phone">
								{" "}
								To pay via phone, call:{" "}
								<a href="tel:+1-888-978-5371">
							    1-888-978-5371
								</a><br />
							  Our team is available Mon-Fri 8am to 8:30 pm ET.
							</div>
						) : (

							<div className="footer_phone">
								{" "}
								To pay via phone, call:{" "}
							  <span x-ms-format-detection="none">
		   	          1-888-978-5371
		            </span>
							  <br />Our team is available Mon-Fri 8 am to 8:30 pm ET.
							{" "}
							</div>


						)}
						 <div>
							<div>
								{" "}
								All checks can be mailed to: {" "}
							</div>
							<div>Eastern U.S.: AIG Private Client Group, P.O. Box 35423 <span style={{display:"inline-block"}}>Newark, NJ 07193-5423</span></div>
							<div>Central/Western U.S.: AIG Private Client Group, P.O. Box 601148 <span style={{display:"inline-block"}}>Pasadena, CA 91189-1148</span></div>
						</div>
			      </div>
					</div>
				</footer>
			</div>
		);
	}


}



// WEBPACK FOOTER //
// ./src/components/atomic/organisms/Footer/Footer.js